import { Alert, Autocomplete, Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, FormGroup, Grid, Skeleton, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { regexConstants } from '../../../../constants/regEx';
import { globalGetService, globalPostService, globalPutService } from '../../../../utils/globalApiServices';
import { checkApiStatus, getTextFieldRows, numberWithCommas, formatCycles } from '../../../../utils';
import { enqueueSnackbar } from 'notistack';
import { getConstantTypesApi, getStorage } from '../../../../shared_elements/actionCreators';
import { useDispatch, useSelector } from 'react-redux';
import { addAssemblysEventApi, getClauseAPi, getMaintenanceListAPI, updateAssemblysEventApi } from '../apiService';
import { trackActivity } from '../../../../utils/mixpanel';
import LessMoreTextFieldComp from '../../../../shared_elements/components/LessMoreTextFieldComp';
import { AttachementsUpload } from '../../../../shared_elements/components';
import { formatBytes } from '../../../../utils/fileUpload';
import { setFileUploadDetails } from '../../../../shared_elements/actions';

const clauseAssetTypeMap = {
  1: "Airframe",
  2: "Engine",
  3: "APU",
  4: "LG",
  5: "Propeller",
  6: "Engine",
  7: "Engine",
  8: "Engine",
  9: "Engine",
};

const EditAssemblysEvent = ({ onToggleModal, tabValue, params, editEvent, getResponseBack, modeType, addAssemblys, setAddAssemblys, openAttachment, fileUpload }) => {
  const dispatch = useDispatch();
  const { constantTypes, storageDetails } = useSelector((state) => state.leases);
  const [isLoading, setLoading] = useState(false);
  const [clauseData, setClauseData] = useState([]);
  const [data, setData] = useState(editEvent?.mode === "add" ? { released: false } : {
    released: false,
    ...editEvent?.data,
    time_since_last_shop_visit_fh: editEvent?.data?.time_since_last_shop_visit_fh ? editEvent?.data?.time_since_last_shop_visit_fh : editEvent?.data?.time_since_last_shop_visit_fh === 0 ? '0' : null,
    time_since_last_shop_visit_fc: editEvent?.data?.time_since_last_shop_visit_fc ? editEvent?.data?.time_since_last_shop_visit_fc : editEvent?.data?.time_since_last_shop_visit_fc === 0 ? '0' : null,
    time_since_last_shop_visit_month: editEvent?.data?.time_since_last_shop_visit_month ? editEvent?.data?.time_since_last_shop_visit_month : editEvent?.data?.time_since_last_shop_visit_month === 0 ? '0' : null,
    time_to_next_shop_visit_fh: editEvent?.data?.time_to_next_shop_visit_fh ? editEvent?.data?.time_to_next_shop_visit_fh : editEvent?.data?.time_to_next_shop_visit_fh === 0 ? '0' : null,
    time_to_next_shop_visit_fc: editEvent?.data?.time_to_next_shop_visit_fc ? editEvent?.data?.time_to_next_shop_visit_fc : editEvent?.data?.time_to_next_shop_visit_fc === 0 ? '0' : null,
    time_to_next_shop_visit_month: editEvent?.data?.time_to_next_shop_visit_month ? editEvent?.data?.time_to_next_shop_visit_month : editEvent?.data?.time_to_next_shop_visit_month === 0 ? '0' : null,
  });
  const [maintenanceList, setMaintenanceList] = useState([]);
  const [error, setError] = useState({});
  const [isDropDownLoading, setIsDropDownLoading] = useState({ maintence: false, constantTypes: false, clause: false, data: false });
  const [uploadfile, setUploadFile] = useState([]);

  useEffect(() => {
    const payload = { constant_types: ["assembly_condition"] };
    getMaintenanceList('skeletonLoader', {});
    getConditionClauseData();
    dispatch(getConstantTypesApi(payload, { setIsDropDownLoading: setIsDropDownLoading }));
    dispatch(getStorage({ lease_slug: params?.params?.leaseSlug, module_name: "delivery_redelivery_maintenance_event" }));
    dispatch(setFileUploadDetails({ attachments: [] }));
  }, []);

  const getMaintenanceList = (loaderType, query = {}) => {
    setIsDropDownLoading?.(prev => ({ ...prev, maintence: true }))
    setLoading(true);
    globalGetService(getMaintenanceListAPI(params, query)).then(response => {
      setIsDropDownLoading?.(prev => ({ ...prev, maintence: false }))
      if (checkApiStatus(response)) {
        let maintenanceEvents = response?.data?.data[0]?.maintenance_events
        setMaintenanceList(maintenanceEvents);
      }
      setLoading(false);
    });
  };

  const onRestErrorKey = (key) => {
    if (["flight_hours", "flight_cycle", "months"].includes(key)) {
      setError((prev) => ({
        ...prev,
        flight_hours: "",
        flight_cycle: "",
        months: ""
      }));
    } else {
      setError((prev) => ({ ...prev, [key]: '' }));
    }
  };

  const onFieldChange = (key, value) => {
    const resetFields = ["condition", "time_since_last_shop_visit_fh", "time_since_last_shop_visit_fc", "time_since_last_shop_visit_month", "time_to_next_shop_visit_fh", "time_to_next_shop_visit_fc", "time_to_next_shop_visit_month"];
    setData((prev) => {
      let updated = { ...prev, [key]: value };
      if (key === "maintenance_type" && !value) {
        resetFields.forEach((field) => {
          updated[field] = null;
        });
      }
      return updated;
    });
    setError((prev) => ({ ...prev, [key]: "" }));
  };


  const onEditEvent = () => {
    const hasMaintenanceType = Boolean(data?.maintenance_type);
    const hasClause = Boolean(data?.redelivery_asset_conditions_for_contract_id);
    const validationInputs = {
      name: data?.name ? "" : "Please enter Name",
      redelivery_asset_conditions_for_contract_id: hasClause ? "" : "Please select Clause",
      condition: hasMaintenanceType && !data?.condition ? "Please select Condition" : "",
    };
    if (
      hasMaintenanceType &&
      data?.condition?.value !== 3 &&
      !(data?.time_since_last_shop_visit_fh || data?.time_to_next_shop_visit_fh || data?.time_since_last_shop_visit_fc || data?.time_to_next_shop_visit_fc || data?.time_since_last_shop_visit_month || data?.time_to_next_shop_visit_month)
    ) {
      enqueueSnackbar('FH, FC, Months. Atleast one value is required', { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
      return;
    }
    if (Object.values(validationInputs).every(val => val === "")) {
      setLoading(true);
      let payload = Object.assign({}, data);

      const conditionValue = data?.condition?.value || data?.condition?.id || data?.condition || null;

      const redeliveryClauseId = data?.redelivery_asset_conditions_for_contract?.id ?? data?.redelivery_asset_conditions_for_contract_id?.id ?? data?.redelivery_asset_conditions_for_contract_id ?? null;

      payload = {
        ...payload,
        maintenance_type_id: hasMaintenanceType ? { value: data?.maintenance_type?.value || data?.maintenance_type?.id } : null,
        ...(hasMaintenanceType && conditionValue ? { condition: { value: conditionValue } } : {}),
        redelivery_asset_conditions_for_contract_id: redeliveryClauseId,
        redelivery_type: data?.redelivery_type || data?.type || "",
        redelivery_exception_done: data?.redelivery_exception_done || data?.delivery_exception_done || "",
        name: data?.name,
        time_since_last_shop_visit_fh: !hasMaintenanceType || data?.time_since_last_shop_visit_fh === "" || conditionValue === 3 ? null : data?.time_since_last_shop_visit_fh,
        time_since_last_shop_visit_fc: !hasMaintenanceType || data?.time_since_last_shop_visit_fc === "" || conditionValue === 3 ? null : data?.time_since_last_shop_visit_fc,
        time_since_last_shop_visit_month: !hasMaintenanceType || data?.time_since_last_shop_visit_month === "" || conditionValue === 3 ? null : data?.time_since_last_shop_visit_month,
        time_to_next_shop_visit_fh: !hasMaintenanceType || data?.time_to_next_shop_visit_fh === "" || conditionValue === 3 ? null : data?.time_to_next_shop_visit_fh,
        time_to_next_shop_visit_fc: !hasMaintenanceType || data?.time_to_next_shop_visit_fc === "" || conditionValue === 3 ? null : data?.time_to_next_shop_visit_fc,
        time_to_next_shop_visit_month: !hasMaintenanceType || data?.time_to_next_shop_visit_month === "" || conditionValue === 3 ? null : data?.time_to_next_shop_visit_month,
      };

      delete payload.delivery_asset_conditions_for_contract_id;
      // delete payload.redelivery_asset_conditions_for_contract;
      delete payload.delivery_exception_done;

      const serviceCall = data.id ? globalPutService(updateAssemblysEventApi(params), payload) : globalPostService(addAssemblysEventApi(params), payload);
      serviceCall.then(response => {
        setLoading(false);
        if (checkApiStatus(response)) {
          enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
          if (uploadfile.length > 0) { fileUpload && fileUpload(response.data.data?.slug || params?.event_slug, modeType); }
          onToggleModal();
          getResponseBack();
          trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `Return Condition ${modeType === 'add' ? 'Add' : 'Edit'} Assembly Event`, success_msg: response?.data?.message, item_slug: params?.params?.leaseSlug, payload: payload, response: response?.data })
        } else {
          enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
          trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `Return Condition ${modeType === 'add' ? 'Add' : 'Edit'} Assembly Event`, error_msg: response?.data?.message, item_slug: params?.params?.leaseSlug, payload: payload, response: response?.data })
        }
      });
    } else {
      setError(validationInputs);
      trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `Return Condition ${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Assembly Event`, error_msg: validationInputs, })
    }
  };

  const getConditionClauseData = () => {
    const clauseAssetType = clauseAssetTypeMap[params?.asset?.asset_type] || null;
    setIsDropDownLoading?.(prev => ({ ...prev, clause: true }))
    globalGetService(getClauseAPi({ lite: true, asset_type: clauseAssetType }))
      .then(response => {
        setIsDropDownLoading?.(prev => ({ ...prev, clause: false }))
        if (checkApiStatus(response)) {
          let responseClause = [];
          const data = response?.data.data?.list;
          data?.map((item) => {
            responseClause.push({ id: item?.id, name: item?.name })
          });
          setClauseData(responseClause || []);
        }
      })
  }

  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Return Condition ${modeType === 'add' ? 'Add' : 'Edit'} Assembly Event`, page_type: page_type, })
  }

  const onFileChange = (data) => {
    setUploadFile(data);
    dispatch(setFileUploadDetails({ attachments: data }))
  }

  const isTableInvalid = Boolean(data?.maintenance_type) && data?.condition?.value !== 3 && !( data?.time_since_last_shop_visit_fh || data?.time_to_next_shop_visit_fh || data?.time_since_last_shop_visit_fc || data?.time_to_next_shop_visit_fc || data?.time_since_last_shop_visit_month || data?.time_to_next_shop_visit_month );

  return (
    <Dialog
      onClose={(event, reason) => { if (reason !== 'backdropClick') { onToggleModal(); } }}
      disableEscapeKeyDown
      className="add-lease-dialog"
      maxWidth="md"
      open={true}
      slotProps={{ paper: { sx: { width: '780px' } } }}
      fullWidth
    >
      <DialogTitle className='dialog-header'>
        <Typography sx={{ marginLeft: '10px' }}>
          {data?.id ? `${editEvent.mode === "view" ? "View" : "Edit"} Event` : "Add Event"}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid size={{ md: 4, xs: 12 }}>
            <Tooltip title={data?.name?.length > 23 ? data?.name : ""} placement="bottom" arrow>
            <TextField
              disabled={tabValue || modeType === "view"}
              label="Name"
              required
              variant="outlined"
              size="small"
              margin="normal"
              fullWidth
              value={data?.name || ""}
              slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 100 } }}
              onFocus={() => onRestErrorKey("name")}
              onChange={(e) => {
                regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("name", e.target.value.trimStart()) : e.preventDefault();
              }}
              error={Boolean(error?.name)}
              helperText={error?.name}
            /></Tooltip>
          </Grid>
          <Grid size={{ md: 4, xs: 12 }}>
            <Autocomplete
              disablePortal
              disableClearable
              width="100%"
              options={clauseData || []}
              getOptionLabel={(o) => o?.name || ""}
              noOptionsText={isDropDownLoading?.clause ? "loading" : "No Option Available"}
              value={data?.redelivery_asset_conditions_for_contract_id || null}
              onChange={(e, value) => onFieldChange("redelivery_asset_conditions_for_contract_id", value)}
              onFocus={() => onRestErrorKey("redelivery_asset_conditions_for_contract_id")}
              slotProps={{
                listbox: { style: { maxHeight: 100, overflowY: "auto" } },
                input: { sx: { boxSizing: "border-box", width: "auto" }, },
              }}
              disabled={modeType === "view"}
              renderInput={(params) => {
                const selectedLabel = params?.inputProps?.value || "";
                return (
                  <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow>
                    <TextField
                      {...params}
                      label="Clause"
                      margin="normal"
                      size="small"
                      required
                      fullWidth
                      slotProps={{
                        inputLabel: { shrink: true, }, input: { ...params?.InputProps, endAdornment: (<>{isDropDownLoading?.clause ? (<CircularProgress color="inherit" size={20} />) : null}{params?.InputProps?.endAdornment}</>) }
                      }}
                      error={Boolean(error.redelivery_asset_conditions_for_contract_id)}
                      helperText={error.redelivery_asset_conditions_for_contract_id}
                      disabled={modeType === "view"}
                    />
                  </Tooltip>)
              }}
            />
          </Grid>
          <Grid size={{ md: 4, xs: 12 }}>
            <Autocomplete
              disablePortal
              width="100%"
              disabled={tabValue || modeType === "view"}
              options={maintenanceList || []}
              getOptionLabel={(o) => o?.name || ""}
              noOptionsText={isDropDownLoading?.maintence ? "loading" : "No Option Available"}
              value={maintenanceList?.find(opt => opt.id === data?.maintenance_type?.value) || data?.maintenance_type || null}
              onChange={(e, value) => onFieldChange("maintenance_type", value)}
              onFocus={() => onRestErrorKey("maintenance_type")}
              slotProps={{
                listbox: { style: { maxHeight: 100, overflowY: "auto" } },
                input: { sx: { boxSizing: "border-box", width: "auto" }, },
              }}
              renderInput={(params) => {
                const selectedLabel = params?.inputProps?.value || "";
                return (
                  <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow>
                    <TextField
                      {...params}
                      label="Maintenance Type"
                      margin="normal"
                      size="small"
                      fullWidth
                      slotProps={{
                        inputLabel: { shrink: true, }, input: { ...params?.InputProps, endAdornment: (<>{isDropDownLoading?.maintence ? (<CircularProgress color="inherit" size={20} />) : null}{params?.InputProps?.endAdornment}</>) }
                      }}
                      sx={{ width: "100%", boxSizing: "border-box", }}
                    />
                  </Tooltip>)
              }}
            />
          </Grid>
          {data?.maintenance_type && (
            <Grid size={{ md: 4, xs: 12 }}>
              <Autocomplete
                disablePortal
                disableClearable
                disabled={tabValue || modeType === "view"}
                required
                options={constantTypes || []}
                getOptionLabel={(option) => option?.label || ""}
                isOptionEqualToValue={(option, val) => option?.value === val?.value}
                noOptionsText={isDropDownLoading?.constantTypes ? "loading" : "No Option Available"}
                value={constantTypes?.find(opt => opt.id === String(data.condition)) || data.condition || null}
                onChange={(e, value) => onFieldChange("condition", value)}
                onFocus={() => onRestErrorKey("condition")}
                slotProps={{
                  listbox: { style: { maxHeight: 100, overflowY: "auto" } },
                  input: { sx: { boxSizing: "border-box", width: "auto" }, },
                }}
                renderInput={(params) => {
                  const selectedLabel = params?.inputProps?.value || "";
                  return (
                    <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow>
                      <TextField
                        {...params}
                        label="Condition"
                        margin='normal'
                        size='small'
                        required
                        error={Boolean(error.condition)}
                        helperText={error.condition}
                        slotProps={{
                          inputLabel: {
                            shrink: true,
                          },
                          input: {
                            ...params?.InputProps, endAdornment: (<>{isDropDownLoading?.constantTypes ? (<CircularProgress color="inherit" size={20} />) : null}
                              {params?.InputProps?.endAdornment}
                            </>
                            )
                          }
                        }}
                      />
                    </Tooltip>)
                }}
              />
            </Grid>)}
          <Grid size={{ md: 4, xs: 12 }}>
            {isDropDownLoading.data ? (<Skeleton variant="rectangular" height={40} />) : (
              <TextField
                label="Type"
                variant="outlined"
                size="small"
                margin="normal"
                fullWidth
                value={data?.redelivery_type || data?.type || ""}
                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 100 } }}
                onChange={(e) => {
                  regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? (() => {
                      const typeValue = e.target.value;
                      setData((prev) => ({ ...prev, redelivery_type: typeValue, type: typeValue }));
                      setError((prev) => ({ ...prev, redelivery_type: '', type: '' }));
                    })()
                    : e.preventDefault();
                }}
                disabled={modeType === "view"}
              />
            )}
          </Grid>
          {data?.maintenance_type && (
            <>
              {data?.condition?.value !== 3 &&
                <Grid size={{ md: 12, xs: 12 }}>
                  <Table className="mui-table-format">
                    <TableHead >
                      <TableRow>
                        <TableCell sx={{ minWidth: '120px' }}></TableCell>
                        <TableCell align='center'>FH*</TableCell>
                        <TableCell align='center'>FC*</TableCell>
                        <TableCell align='center'>Months* </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>Time Since Last Shop Visit</TableCell>
                        <TableCell>
                          <TextField
                            id='time_since_last_shop_visit_fh'
                            value={(Boolean(data?.time_to_next_shop_visit_fh) || data?.condition?.value === 3 || modeType === "view") && data?.time_since_last_shop_visit_fh !== '' && data?.time_since_last_shop_visit_fh !== null && data?.time_since_last_shop_visit_fh !== undefined ? numberWithCommas(data?.time_since_last_shop_visit_fh) : (data?.time_since_last_shop_visit_fh || '')}
                            onChange={(e) => regexConstants.numberWithDot.test(e.target.value) || e.target.value === "" ? onFieldChange('time_since_last_shop_visit_fh', e.target.value) : e.preventDefault()}
                            onFocus={() => { onRestErrorKey('time_since_last_shop_visit_fh'); onRestErrorKey('time_to_next_shop_visit_fh') }}
                            disabled={Boolean(data?.time_to_next_shop_visit_fh) || data?.condition?.value === 3 || modeType === "view"}
                            margin='normal'
                            size='small'
                            variant='outlined'
                            error={Boolean(error.time_since_last_shop_visit_fh)}
                            helperText={error.time_since_last_shop_visit_fh}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            id='time_since_last_shop_visit_fc'
                            value={(Boolean(data?.time_to_next_shop_visit_fc) || data?.condition?.value === 3 || modeType === "view") && data?.time_since_last_shop_visit_fc !== '' && data?.time_since_last_shop_visit_fc !== null && data?.time_since_last_shop_visit_fc !== undefined ? formatCycles(data?.time_since_last_shop_visit_fc) : (data?.time_since_last_shop_visit_fc || '')}
                            onChange={(e) => regexConstants.numberWithDot.test(e.target.value) || e.target.value === "" ? onFieldChange('time_since_last_shop_visit_fc', e.target.value) : e.preventDefault()}
                            onFocus={() => { onRestErrorKey('time_since_last_shop_visit_fc'); onRestErrorKey('time_to_next_shop_visit_fc') }}
                            disabled={Boolean(data?.time_to_next_shop_visit_fc) || data?.condition?.value === 3 || modeType === "view"}
                            margin='normal'
                            size='small'
                            variant='outlined'
                            error={Boolean(error.time_since_last_shop_visit_fc)}
                            helperText={error.time_since_last_shop_visit_fc}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            id='time_since_last_shop_visit_month'
                            value={data?.time_since_last_shop_visit_month || ""}
                            onChange={(e) => regexConstants.onlyNumeric.test(e.target.value) || e.target.value === "" ? onFieldChange('time_since_last_shop_visit_month', e.target.value) : e.preventDefault()}
                            onFocus={() => { onRestErrorKey('time_since_last_shop_visit_month'); onRestErrorKey('time_to_next_shop_visit_month') }}
                            disabled={Boolean(data?.time_to_next_shop_visit_month) || data?.condition?.value === 3 || modeType === "view"}
                            margin='normal'
                            size='small'
                            variant='outlined'
                            error={Boolean(error.time_since_last_shop_visit_month)}
                            helperText={error.time_since_last_shop_visit_month}
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Time To Next Shop Visit</TableCell>
                        <TableCell>
                          <TextField
                            id='time_to_next_shop_visit_fh'
                            value={(Boolean(data?.time_since_last_shop_visit_fh) || data?.condition?.value === 3 || modeType === "view") && data?.time_to_next_shop_visit_fh !== '' && data?.time_to_next_shop_visit_fh !== null && data?.time_to_next_shop_visit_fh !== undefined ? numberWithCommas(data?.time_to_next_shop_visit_fh) : (data?.time_to_next_shop_visit_fh || "")}
                            onChange={(e) => regexConstants.numberWithDot.test(e.target.value) || e.target.value === "" ? onFieldChange('time_to_next_shop_visit_fh', e.target.value) : e.preventDefault()}
                            onFocus={() => { onRestErrorKey('time_since_last_shop_visit_fh'); onRestErrorKey('time_to_next_shop_visit_fh') }}
                            disabled={Boolean(data?.time_since_last_shop_visit_fh) || data?.condition?.value === 3 || modeType === "view"}
                            margin='normal'
                            size='small'
                            variant='outlined'
                            error={Boolean(error.time_to_next_shop_visit_fh)}
                            helperText={error.time_to_next_shop_visit_fh}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            id='time_to_next_shop_visit_fc'
                            value={(Boolean(data?.time_since_last_shop_visit_fc) || data?.condition?.value === 3 || modeType === "view") && data?.time_to_next_shop_visit_fc !== '' && data?.time_to_next_shop_visit_fc !== null && data?.time_to_next_shop_visit_fc !== undefined ? formatCycles(data?.time_to_next_shop_visit_fc) : (data?.time_to_next_shop_visit_fc || "")}
                            onChange={(e) => regexConstants.numberWithDot.test(e.target.value) || e.target.value === "" ? onFieldChange('time_to_next_shop_visit_fc', e.target.value) : e.preventDefault()}
                            onFocus={() => { onRestErrorKey('time_since_last_shop_visit_fc'); onRestErrorKey('time_to_next_shop_visit_fc') }}
                            disabled={Boolean(data?.time_since_last_shop_visit_fc) || data?.condition?.value === 3 || modeType === "view"}
                            margin='normal'
                            size='small'
                            variant='outlined'
                            error={Boolean(error.time_to_next_shop_visit_fc)}
                            helperText={error.time_to_next_shop_visit_fc}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            id='time_to_next_shop_visit_month'
                            value={data?.time_to_next_shop_visit_month || ""}
                            onChange={(e) => regexConstants.onlyNumeric.test(e.target.value) || e.target.value === "" ? onFieldChange('time_to_next_shop_visit_month', e.target.value) : e.preventDefault()}
                            onFocus={() => { onRestErrorKey('time_since_last_shop_visit_month'); onRestErrorKey('time_to_next_shop_visit_month') }}
                            disabled={Boolean(data?.time_since_last_shop_visit_month) || data?.condition?.value === 3 || modeType === "view"}
                            margin='normal'
                            size='small'
                            variant='outlined'
                            error={Boolean(error.time_to_next_shop_visit_month)}
                            helperText={error.time_to_next_shop_visit_month}
                          />
                        </TableCell>
                      </TableRow>
                      
                      {isTableInvalid ? 
                      <TableRow>
                        <TableCell colSpan={4} sx={{ borderBottom: "none", pt: 0 }}>
                          <Alert severity="info" sx={{  background: 'none',color: "#d42f2f", padding: "0px", fontSize: "10px", alignItems: "center", '& .MuiAlert-icon': { alignItems: "center" }, '& .MuiAlert-icon svg': { fontSize: "15px", color: "#d42f2f" } }}>FH, FC, Months. Atleast one value is required.</Alert>
                        </TableCell>
                      </TableRow> : null}

                    </TableBody>
                  </Table>
                </Grid>}</>)}
          <Grid size={{ md: 12, xs: 12 }}>
            {isDropDownLoading.data ? (<Skeleton variant="rectangular" height={40} />) : (
              <TextField
                label="Terms"
                variant="outlined"
                size="small"
                margin="normal"
                fullWidth
                value={data?.redelivery_terms || ""}
                onChange={(e) => {
                  regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("redelivery_terms", e.target.value.trimStart()) : e.preventDefault();
                }}
                slotProps={{ inputLabel: { shrink: true }}}
                multiline
                rows={getTextFieldRows(data?.redelivery_terms, 3, 95)}
                disabled={modeType === "view"}
              />
            )}
          </Grid>
          <Grid size={{ md: 12, xs: 12 }}>
            {isDropDownLoading.data ? (<Skeleton variant="rectangular" height={40} />) : (
              <TextField
                label="Post Delivery"
                variant="outlined"
                size="small"
                margin="normal"
                fullWidth
                value={data?.redelivery_post_delivery || ""}
                onChange={(e) => {
                  regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("redelivery_post_delivery", e.target.value.trimStart()) : e.preventDefault();
                }}
                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 255 } }}
                multiline
                rows={getTextFieldRows(data?.redelivery_post_delivery, 3, 95)}
                disabled={modeType === "view"}
              />
            )}
          </Grid>
          <Grid size={{ md: 12, xs: 12 }}>
            <TextField
              id="redelivery_exception_done"
              label="Exception Done"
              variant="outlined"
              readOnly={true}
              size="small"
              margin="normal"
              slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 255 } }}
              value={data?.redelivery_exception_done || data?.delivery_exception_done || ""}
              onChange={(e) => {
                regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("redelivery_exception_done", e.target.value.trimStart()) : e.preventDefault();
              }}
              error={Boolean(error.redelivery_exception_done)}
              helperText={error.redelivery_exception_done}
              fullWidth
              multiline
              rows={getTextFieldRows(data?.redelivery_exception_done || data?.delivery_exception_done, 3, 95)}
              disabled={modeType === "view"}
            />
          </Grid>
          {modeType === "view" ? <Grid item size={{ md: 12, xs: 12 }}>
            <LessMoreTextFieldComp label='Remarks' value={data?.remarks || ""} rows={getTextFieldRows(data?.remarks, 3, 95)} />
          </Grid> :
            <Grid size={{ md: 12, xs: 12 }}>
              <TextField
                id="remarks"
                value={data?.remarks || ''}
                label="Remarks"
                variant="outlined"
                size="small"
                margin="normal"
                fullWidth
                slotProps={{ inputLabel: { shrink: true } }}
                sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                disabled={modeType === "view"}
                multiline
                rows={3}
                onChange={(e) => {
                  regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("remarks", e.target.value.trimStart()) : e.preventDefault();
                }}
              />
            </Grid>}
          <Grid size={{ md: 6, xs: 12 }}>
            <FormControlLabel
              control={ <Checkbox checked={!!data?.released} onChange={(e) => onFieldChange("released", e.target.checked)} size="small" color="primary" disabled={modeType === "view"} /> }
              label="Released"
            />
          </Grid>
          <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>
            <Box className="responsive-buttons">
              {
                data?.id && data?.attachments?.length ?
                  <Button size='small' variant='outlined' color="primary" sx={{ marginBottom: '10px' }} onClick={() => openAttachment && openAttachment()}>
                    {`${data.attachments.length}: Attachments`}
                  </Button> : null
              }
              <Button className="available-space-btn" disableRipple size='small' variant='outlined' color='primary'>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
            </Box>
            {modeType === "view" ? null : <AttachementsUpload onFileChange={onFileChange} attachments={data?.attachments} remainingStorage={storageDetails?.remaining_storage} />}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ marginRight: '15px' }}>
        <Button className="cancel-btn" disabled={isLoading} variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
        {modeType === "view" ? null : <Button className="btn-primary" variant='contained' size='small' onClick={() => { handleItemClicked('Save Button'); onEditEvent(); }}> {isLoading ? <CircularProgress color='inherit' size={25} /> : "SAVE"} </Button>}
      </DialogActions>
    </Dialog>
  );
};

export default EditAssemblysEvent;
